export const OPEN_POSTAL_CODE_MODAL_EVENT = 'open-header-cep-modal'

export function dispatchOpenPostalCodeModal() {
  if (typeof window === 'undefined') {
    return
  }

  window.dispatchEvent(new CustomEvent(OPEN_POSTAL_CODE_MODAL_EVENT))
}

export function subscribeOpenPostalCodeModal(onOpen: () => void) {
  if (typeof window === 'undefined') {
    return () => undefined
  }

  const handler = () => onOpen()

  window.addEventListener(OPEN_POSTAL_CODE_MODAL_EVENT, handler)

  return () => {
    window.removeEventListener(OPEN_POSTAL_CODE_MODAL_EVENT, handler)
  }
}
